"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSpacing = parseSpacing;
exports.padding = padding;
exports.margin = margin;

var _core = require("@emotion/core");

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _ifRtl2 = _interopRequireDefault(require("./ifRtl"));

var _propsEvalOrReturn = _interopRequireDefault(require("./propsEvalOrReturn"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function parseSpacing(value) {
  if (value === undefined) return 'inherit';
  if (typeof value === 'string') return value;
  return "".concat(value, "px");
}

function spacing(property, argumentSpacingValue) {
  return function (props) {
    var spacingValue = (0, _propsEvalOrReturn["default"])(argumentSpacingValue, props);
    var top;
    var bottom;
    var left;
    var right;

    if (!(0, _isObject["default"])(spacingValue)) {
      top = spacingValue;
      bottom = spacingValue;
      left = spacingValue;
      right = spacingValue;
    } else {
      var _ref = spacingValue;
      top = _ref.top;
      bottom = _ref.bottom;
      right = _ref.right;
      left = _ref.left;
    }

    if (top === bottom && bottom === right && right === left) {
      return /*#__PURE__*/(0, _core.css)(property, ":", parseSpacing(top), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
    }

    var _ifRtl = (0, _ifRtl2["default"])({
      left: right,
      right: left
    }, {
      left: left,
      right: right
    })(props),
        leftSpacing = _ifRtl.left,
        rightSpacing = _ifRtl.right;

    var args = [];

    if (top !== undefined) {
      args.push("".concat(property, "-top:").concat(parseSpacing(top), ";"));
    }

    if (rightSpacing !== undefined) {
      args.push("".concat(property, "-right:").concat(parseSpacing(rightSpacing), ";"));
    }

    if (bottom !== undefined) {
      args.push("".concat(property, "-bottom:").concat(parseSpacing(bottom), ";"));
    }

    if (leftSpacing !== undefined) {
      args.push("".concat(property, "-left:").concat(parseSpacing(leftSpacing), ";"));
    }

    return /*#__PURE__*/_core.css.apply(void 0, args);
  };
}

function padding(value) {
  return spacing('padding', value);
}

function margin(value) {
  return spacing('margin', value);
}